
import filters from "@/filters";
import { Component, Prop, Vue } from "vue-property-decorator";
import { EnumHelper, JobTypeEnum } from "@/constants/enum.constant";

@Component({
  components: {},
  filters,
})
export default class ModalJobDetail extends Vue {
  @Prop({ default: null })
  private job!: any;

  private types = EnumHelper(JobTypeEnum);
}
